import { Text } from '@cmpsr/components';

type ModalIntroWizardStepTitleProps = {
  activeStep: number;
};

export default function ModalIntroWizardStepTitle(props: ModalIntroWizardStepTitleProps) {
  return renderSwitch(props.activeStep);
}

function renderSwitch(activeStep: number): React.ReactNode {
  switch (activeStep) {
    case 1: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Better data +more{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            proactive
          </Text>{' '}
          testing
        </Text>
      );
    }
    case 2: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          No{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            more
          </Text>{' '}
          generic screening guidelines
        </Text>
      );
    }
    case 3: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Everything you need to know to{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            get tested
          </Text>{' '}
        </Text>
      );
    }
    case 4: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            Share your results
          </Text>{' '}
          to update your risk profile
        </Text>
      );
    }
    case 5: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            Let’s go!
          </Text>
        </Text>
      );
    }
  }
}
